import crypto from "crypto-js";

export const WEBSITE_NAME = "Visual Vibes";
export const WEBSITE_URL = "https://visualvibes.shop";

export const API_ACCESS_URL = "https://api.visualvibes.shop/router/";
export const API_PAYMENTS_URL = "http://localhost/shop/payments/router/";
export const IP_ACCESS_URL = "https://api64.ipify.org/?format=json";
export const LIVE_CHAT_URL = "";

export const CUSTOM_USER_AGENT = "NINJA_CRIPT_1.0.0.1";

// apis
export const API_GET_HOME_INFO = API_ACCESS_URL + "route-get-home-info";
export const API_SIGNIN_ACCOUNT = API_ACCESS_URL + "route-signin";
export const API_UPDATE_ACCOUNT = API_ACCESS_URL + "route-update-account";
export const API_GET_PROFILE = API_ACCESS_URL + "route-get-profile-info";
export const API_GET_MYCART = API_ACCESS_URL + "route-get-mycart";
export const API_GET_PRODUCT_INFO = API_ACCESS_URL + "route-get-product-info";
export const API_GET_CART_PRODUCTS = API_ACCESS_URL + "route-get-cart";
export const API_UPDATE_CART_PRODUCTS = API_ACCESS_URL + "route-update-cart";
export const API_ADD_TO_CART = API_ACCESS_URL + "route-add-to-cart";
export const API_CUSTOMIZE_ADD_TO_CART = API_ACCESS_URL + "route-customize-add-to-cart";
export const API_GET_SEARCHED_PRODUCTS = API_ACCESS_URL + "route-get-searched-products";
export const API_ADD_ADDRESS = API_ACCESS_URL + "route-add-address";
export const API_GET_MYADDRESSES = API_ACCESS_URL + "route-get-myaddresses";
export const API_GET_ADDRESS_DETAILS = API_ACCESS_URL + "route-get-address-details";
export const API_UPDATE_ADDRESS = API_ACCESS_URL + "route-update-address";
export const API_GET_CHECKOUT = API_ACCESS_URL + "route-get-checkout";
export const API_APPLY_COUPON = API_ACCESS_URL + "route-apply-coupon";
export const API_CONFIRM_ORDER = API_ACCESS_URL + "route-confirm-order";
export const API_GET_ORDERS = API_ACCESS_URL + "route-get-orders";
export const API_GET_ORDER_DETAILS = API_ACCESS_URL + "route-get-order-details";
export const API_GET_CUSTOMIZATION = API_ACCESS_URL + "route-get-customization";
export const API_GET_DOCUMENT = API_ACCESS_URL + "route-get-document";

// payment apis
export const API_CREATE_RAZORPAY_ORDER = API_ACCESS_URL + "route-create-razorpay-order";
export const API_VERIFY_RAZORPAY_ORDER = API_ACCESS_URL + "route-verify-razorpay-order";

export function redirectTo(url) {
  window.location.replace(url);
}

export function openNewPage(url) {
  if (url != "none") {
    window.location.href = url;
  }
}

export function getFullURL() {
  return window.location.href;
}

export function getHostName() {
  return window.location.protocol + '//' + window.location.host;
}

export function getURLParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

export function getInternetStatus() {
  if (navigator.onLine) {
    return true;
  } else {
    return false;
  }
}

export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}


export function getRandomString(length) {
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  let result = ' ';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

export function copyText(text) {

  var textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    document.body.removeChild(textArea);
  } catch (err) {
    return true;
  }

  return true;
}

export function generateAuthToken(token, ip) {
  return crypto.SHA256(token).toString() + 'i16ni14j1' + ip + '5s3189pt';
}
